<template>
  <div>
    <Menu></Menu>
    <div class="admin-container">
      <div class="left-sidebar">
        <div class="left-sidebar__header">
          <img src="/static/img/pictos/stockcamion.svg" class="">
          <span>Véhicules</span>
        </div>
      </div>
      <div class="content-area">
        <h1>Véhicules</h1>
        <b-container fluid>
          <b-row>
            <b-col>
              <backlink/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="ibox">
                <div class="ibox-content">
                  <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options"></AdminForm>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/Global/Menu";
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "AdminVehicleForm",
  components: {
    Menu,
    AdminForm
  },
  data() {
    return {
      config: config,
      form: {},
      isBusy: false
    };
  },
  computed: {
    options: function() {
      return {
      };
    }
  },
  mounted() {
    this.$store.dispatch("vehicle/getAll");

    // Edition
    if (this.$route.name == config.edit_route_name) {
      this.isBusy = true;
      this.$store
        .dispatch(config.store_namespace + "/getAll", true)
        .then(() => {
          let item = this.$store.getters[config.store_namespace + "/getItem"](
            this.$route.params.id
          );
          this.form = {
            ...item,
          };
          this.isBusy = false;
        });
    }
  }
};
</script>


<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: white;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $grisclair;
    border-radius: 20px;
    height: 5px;
  }

  .admin-container{ display: flex; margin-top: 0;
    nav{ height: 75px; }
  }
  .left-sidebar{ width: 300px;
    &__header{ background-color: $color3; display: flex; height: 300px; flex-direction: column; align-items: center; justify-content: center;
      img{ width: 100px; margin-left: 35px; }
      span{ color: white; font-family: 'ClanFFBlack'; font-size: 20px; margin-top: 25px; text-transform: uppercase; }
    }
  }
  .container-fluid{ padding: 0; }
  .content-area{ width: calc(100% - 300px); padding: 40px 7%; margin-top: 0;
    h1{ font-family: 'ClanFFBlack'; color: $color3; font-size: 25px; margin-bottom: 0; position: relative; padding-bottom: 30px;
      &:before{ content: ""; display: block; width: 60px; height: 8px; background-color: $color3; border-radius: 4px; position: absolute; bottom: 0; }
    }
    .orders__list{ overflow: auto; height: 500px; padding-right: 20px; }
    &--mobile{ width: 100%; padding: 0; margin-top: 0;
      .orders__list{ height: auto; padding: 0; }
    }
  }
  .filters{ display: flex; margin-bottom: 50px;
    .filter{ height: 35px; line-height: 35px;  border: 1px solid $color1; }
    input[type=text]{ margin-left: 10px; width: auto; flex: 1; padding: 0 15px; font-size: 12px; }
    select{ width: 150px; font-size: 12px; }
  }
</style>



// WEBPACK FOOTER //
// src/components/Vehicle/AdminVehicleForm.vue